import { useAnalytics } from "@/src/sb/components/Analytics"
import React from "react"

import DesktopTopNav from "./DesktopTopNavbar"
import MobileNavbar, { MobileNavbarProps } from "./MobileNavbar"
import MobileTopNavBar from "./MobileTopNavbar"
import { DesktopTopNavProps } from "./types"

export type NavigationBarProps = DesktopTopNavProps & MobileNavbarProps

const NavigationBar = ({
  collapseSearchInput,
  ...props
}: NavigationBarProps) => {
  const analytics = useAnalytics()

  const {
    userType,
    onSearchChange,
    username = "Account",
    searchText,
    showSearch,
    loading = false,
    onNavItemClick = (navItem, props?: Record<string, any>) => {
      analytics?.clickNavItem(navItem, {
        ...props
      })
    },
    navigationMenu,
    setNextQueryParam,
    ...desktopProps
  } = props

  return (
    <>
      <div className="hidden mobile:block portrait_tablet:block tablet:block">
        <MobileTopNavBar
          onSearchChange={onSearchChange}
          searchText={searchText}
          onNavItemClick={onNavItemClick}
          userType={userType}
          showSearch={showSearch}
          loading={loading}
          setNextQueryParam={setNextQueryParam}
        />

        <div className="fixed bottom-0 w-full z-10">
          <MobileNavbar
            userType={userType}
            onNavItemClick={onNavItemClick}
            navigationMenu={navigationMenu}
            setNextQueryParam={setNextQueryParam}
          />
        </div>
      </div>
      <div className="block mobile:hidden portrait_tablet:hidden tablet:hidden">
        <DesktopTopNav
          userType={userType}
          onSearchChange={onSearchChange}
          searchText={searchText}
          username={username}
          loading={loading}
          collapseSearchInput={collapseSearchInput}
          onNavItemClick={onNavItemClick}
          showSearch={showSearch}
          navigationMenu={navigationMenu}
          setNextQueryParam={setNextQueryParam}
          {...desktopProps}
        />
      </div>
    </>
  )
}

export default NavigationBar
